module.exports = __webpack_public_path__ + "img/card-tick.c098c43c.svg";